module.exports = __webpack_public_path__ + "img/5.958973d9.png";